"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _Discussion = require("../Discussion");

var _SurveyModal = require("components/SurveyModal");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class4, _temp2;

var ApplicationDeclinedBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ApplicationDeclinedBody, _Component);

  function ApplicationDeclinedBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ApplicationDeclinedBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ApplicationDeclinedBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ApplicationDeclinedBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("p", null, this.node.account.fullName, " has declined ", this.node.applicationFor, "'s application to ", this.node.catalogItem.title, "."), _react.default.createElement("p", null, "Declined:", _react.default.createElement("br", null), new Date(this.node.created).format('F j, Y g:i A')), this.node.comment && _react.default.createElement("hr", null), this.node.comment && _react.default.createElement("p", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.node.comment));
    }
  }]);
  return ApplicationDeclinedBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ApplicationDeclinedNode = (_class3 = (_temp2 = _class4 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ApplicationDeclinedNode, _Component2);

  function ApplicationDeclinedNode() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ApplicationDeclinedNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ApplicationDeclinedNode)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "commentPosted", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "trackData", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "discussion", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      expanded: false,
      userProfile: null,
      submitting: false
    };
    return _this2;
  }

  babelHelpers.createClass(ApplicationDeclinedNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(_node.default, {
          node: this.node.node,
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          discussion: this.discussion
        }, _react.default.createElement(ApplicationDeclinedBody, {
          node: this.node.node
        })));
      }

      return null;
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this3 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The application has been deleted.');

        _this3.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }]);
  return ApplicationDeclinedNode;
}(_react.Component), _class4._nameIndex = 0, _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdatedEvent"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdated"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doDelete"), _class3.prototype)), _class3);
exports.default = ApplicationDeclinedNode;